export enum MarkerType {
  THUMBNAIL = 'theme',
  THUMBNAIL_SMALL = 'thumbnailSmall', // 홈 > 타임라인 지도뷰 용
  CATEGORY = 'category', // 데일리 브리핑 마커, 테마리스트에서 쓰임
  UPCOMING = 'upcoming', // 타임라인 페이지 > 지도뷰 > 업커밍(예약/주문) 마커
  TIMELINE_CATEGORY = 'timelineCategory', // 타임라인 페이지 > 지도뷰 > 카테고리 아이콘 마커
  DOT = 'dot', // 점마커, 홈 > 타임라인 지도뷰 용
  FOOTPRINT = 'footprint', // 발자국 마커
}

export const MAPS = {
  NOW: new Date().getTime(),
  ONE_MINUTE: 1000 * 60 * 1,
  FOLDER_SPLIT_MODE: false, // 내가 만든 리스트, 저장한 리스트 분할리스트 모드 여부
  FOLDER_SPLIT_MODE_FIRST_LIMIT: 2, // 분할모드 시 첫 화면 노출 제한
  FOLDER_FIRST_LIMIT: 10, // 첫 화면 노출 제한
  FOLDER_MORE_LIMIT: 10, // 더보기 노출 제한 (5건 -> 10건 더보기 참고: #2165)
  BOOKMARK_LIMIT: 5,
  FOLDER_MAX_LIMIT: 400,
  FOLDER_MAX_LIMIT_FOR_API: 1000, // #2176
  BOOKMARK_MAX_LIMIT: 1000,
  LAZY_RENDERING_DELAY: 350,
  LOADER_ANIMATION_DELAY: 50,
  LOADER_MAX_DELAY: 3000, // 로딩 최대 노출 제한 딜레이
  ZOOM_LEVEL: {
    COUNTRY: 2,
    SI_DO: 5,
    SI_GUN_GU: 12,
    EUP_MYUN_DONG: 14,
    STREET: 16,
    REAL_ESTATE: 20,
  },
  FILTER_OPTIONS: {
    all: 'all',
    my: 'my',
    follow: 'follow',
  },
  FILTER_LABELS: {
    all: '전체 리스트',
    my: '내가 만든 리스트',
    follow: '저장한 리스트',
  },
  FILTER_COUNT_KEY: {
    all: 'allFolderCount',
    my: 'myFolderCount',
    follow: 'followFolderCount',
  },
  SORT_OPTIONS: {
    lastUseTime: 'lastUseTime',
    name: 'name',
  },
  SORT_LABELS: {
    lastUseTime: '최신순',
    name: '가나다순',
  },
  PUBLICATION_STATUS: {
    N: 'N', // 비공개
    R: 'R', // 전체공개, 발견하기 미노출
    S: 'S', // 전체공개, 발견하기 노출
  },
}
